import './Logo.css';

// Brand colors live here and in public/favicon.svg. The bracket uses a lighter
// blue than the site accent (#2563eb) so it holds its contrast on the ink tile.
const INK = '#0f172a';
const BRACKET_BLUE = '#3b82f6';

/**
 * The split-K mark: a stem and a code bracket that read as a K.
 * At favicon sizes the gap closes and it becomes a solid K.
 */
export const LogoMark = ({ className = '' }) => (
  <svg
    className={`pk-logo__mark ${className}`.trim()}
    viewBox="0 0 64 64"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="64" height="64" rx="15" fill={INK} />
    <path
      d="M21.5 18v28"
      stroke="#ffffff"
      strokeWidth="7.5"
      strokeLinecap="round"
    />
    <path
      d="M44 18 31 32l13 14"
      fill="none"
      stroke={BRACKET_BLUE}
      strokeWidth="7.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Projects Kart logo. Decorative: the link around it carries the accessible name.
 *
 * <Link to="/" aria-label="Projects Kart home"><Logo /></Link>
 *
 * variant: 'full' (mark + wordmark), 'mark', or 'wordmark'.
 * Sized by font-size: the wordmark is 1em, the mark 1.75em.
 */
const Logo = ({ variant = 'full', className = '' }) => (
  <span className={`pk-logo ${className}`.trim()}>
    {variant !== 'wordmark' && <LogoMark />}
    {variant !== 'mark' && (
      <span className="pk-logo__word" aria-hidden="true">
        projectskart
        <span className="pk-logo__cursor" />
      </span>
    )}
  </span>
);

export default Logo;
